var NetworkEditor = require('networkeditor');
var OverlayContainerView = require('overlaycontainerview');


var AddNetworkView = Backbone.View.extend({
    el: '#addNetworkContainer',
    initialize: function (options) {
        this.selected = false;
        
        this.editorContainer = $('#addNetworkEditor');
        
        this.buffersFooter = $('#buffersFooter');
        this.buttonContainer = $('.addNetworkButton').on('buttonClick', _.bind(function () {
            this.model.trigger('navigate', '?/addNetwork', {trigger: true});
        }, this));
        this.buttonVisible = false;
        
        this.limits = $('#addNetworkLimits');
        this.connectionLimits = this.$('.addNetworkConnectionLimit');

        this.model.bind('change', this.sessionChange, this);
        this.model.bind('featureChange:upgrades', this.renderLimits, this);
        this.model.connections.bind('change', this.renderLimits, this);
        
        this.overlay = new OverlayContainerView({
            model: this.model,
            session: this.model
        });
        
        this.render();
    },
    showLimits: function () {
        this.limits.show();
    },
    hideLimits: function () {
        this.limits.hide();
    },
    toggleLimits: function (show) {
        this.limits.toggle(show);
    },
    render: function () {
        var idPrefix = "addNetwork";
        this.editor = new NetworkEditor({
            session: this.model,
            action: this.model.addNetwork,
            className: 'addNetworkForm',
            id: idPrefix + 'Form',
            classPrefix: "addNetwork",
            idPrefix: idPrefix,
            submitLabel: "Join network",
            cellGroups: [
                NetworkEditor.CELL_GROUPS.network,
                NetworkEditor.CELL_GROUPS.slack,
                NetworkEditor.CELL_GROUPS.identity,
                NetworkEditor.CELL_GROUPS.channels,
                NetworkEditor.CELL_GROUPS.advanced
            ],
            callback: _.bind(function (response) {
                if (response.success) {
                    // makeserver may come before this response
                    var connection = this.model.getConnection(response.cid);
                    if (connection) {
                        connection.select();
                    } else {
                        this.model.setFocusOnMakeServer(response.cid);
                    }
                }
            }, this)
        });
        this.editorContainer.append(this.editor.render().el);
        this.editor.renderSelectComplete(this.editorContainer); // shitty plugin
        
        $(this.el).append(this.overlay.render().el);
        
        this.model.bind('change:nick', this.renderUser, this);
        this.model.bind('change:realname', this.renderUser, this);
    },
    renderUser: function () {
        this.editor.setUser(this.model.getUser());
    },
    sessionChange: function () {
        this.renderLimits();
        this.showButton();
    },
    renderLimits: function () {
        var nets = this.model.getLimit('networks');
        var s = '';
        if (nets != 1) {
            s = 's';
        }
        var text = nets + ' outside connection' + s;
        this.connectionLimits.text(text);
        this.toggleLimits(this.model.areConnectionsLimited() && !!this.model.numActiveConnections());
    },
    showButton: function () {
        if (!this.buttonVisible) {
            this.buffersFooter.fadeIn('fast');
            this.buttonVisible = true;
        }
    },
    hideButton: function () {
        if (this.buttonVisible) {
            this.buffersFooter.fadeOut('fast');
            this.buttonVisible = false;
        }
    },
    isSelected: function () {
        return this.selected;
    },
    show: function (bufferParts) {
        this.selected = true;
        
        $(this.el).show();
        this.buttonContainer.addClass('addNetworkButton--selected');
        
        var prefillUser = this.model.getUser().clone();
        var nick = this.model.getNick();
        prefillUser.set({'nick': nick});
        this.editor.prefill(prefillUser, bufferParts);
        this.editor.focusNetwork();
    },
    hide: function () {
        if (this.isSelected()) {
            this.selected = false;
            this.buttonContainer.removeClass('addNetworkButton--selected');
            $(this.el).hide();
        }
    },
    // This will get called from MainAreaView
    renderOverlay: function (overlay) {
        this.overlay.append(overlay);
        
        return this;
    }
});


module.exports = AddNetworkView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/addnetworkview.js
// module id = f6UI
// module chunks = 1